import { RemoteOngoingActivitiesByCourse } from 'data/usecases';
import { OngoingActivitiesByCourseUseCaseInterface } from 'domain/usecases';
import { makeApiUrlAdminEntity } from 'main/factories/http/api-url-factory';
import { makeAxiosHttpClient } from 'main/factories/http/axios-http-client-factory';

export const makeRemoteOngoingActivitiesByCourse =
  (): OngoingActivitiesByCourseUseCaseInterface =>
    new RemoteOngoingActivitiesByCourse(
      makeApiUrlAdminEntity(),
      makeAxiosHttpClient(),
    );
